// src/pages/LoginPage.js
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff, Close } from "@mui/icons-material";
import BrandLogo from "../components/BrandLogo";
import "./LoginPage.css";

const translations = {
  mr: {
    "login-title": "लॉगिन",
    "login-subtitle": "गुरुपीठ पोर्टल",
    "username-label": "वापरकर्तानाव",
    "password-label": "पासवर्ड",
    "forgot-password": "पासवर्ड विसरलात?",
    "login-button": "लॉगिन करा",
    "username-required": "वापरकर्तानाव आवश्यक आहे",
    "password-required": "पासवर्ड आवश्यक आहे",
  },
  en: {
    "login-title": "Login",
    "login-subtitle": "Dindori Official Portal",
    "username-label": "Username",
    "password-label": "Password",
    "forgot-password": "Forgot Password?",
    "login-button": "Login",
    "username-required": "Username is required",
    "password-required": "Password is required",
  },
};

const LoginPage = () => {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  
  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });
  
  const [showPassword, setShowPassword] = useState(false);

  const t = (key) => translations[lang][key] || translations["en"][key];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.username.trim()) {
      newErrors.username = t("username-required");
    }
    
    if (!formData.password.trim()) {
      newErrors.password = t("password-required");
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Handle login logic here
      console.log("Login attempt:", formData);
      // After successful login, navigate to dashboard or home
      // navigate("/dashboard");
    }
  };

  const handleForgotPassword = () => {
    // Navigate to forgot password page or show modal
    navigate("/forgot-password");
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          {/* Close Button */}
          <IconButton
            className="close-button"
            onClick={() => navigate("/")}
            aria-label="Close"
          >
            <Close />
          </IconButton>

          {/* Logo */}
          <div className="login-logo">
            <BrandLogo />
          </div>

          {/* Header */}
          <div className="login-header">
            <h1 className="login-title">{t("login-title")}</h1>
            <p className="login-subtitle">{t("login-subtitle")}</p>
          </div>

          {/* Login Form */}
          <form className="login-form" onSubmit={handleSubmit}>
            {/* Username Field */}
            <div className="form-group">
              <TextField
                fullWidth
                name="username"
                label={t("username-label")}
                variant="outlined"
                value={formData.username}
                onChange={handleChange}
                error={!!errors.username}
                helperText={errors.username}
                autoComplete="username"
                autoFocus
              />
            </div>

            {/* Password Field */}
            <div className="form-group">
              <TextField
                fullWidth
                name="password"
                label={t("password-label")}
                type={showPassword ? "text" : "password"}
                variant="outlined"
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* Forgot Password Link */}
            <div className="forgot-password-container">
              <button
                type="button"
                className="forgot-password-link"
                onClick={handleForgotPassword}
              >
                {t("forgot-password")}
              </button>
            </div>

            {/* Login Button */}
            <button type="submit" className="login-button">
              {t("login-button")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;